import { render, staticRenderFns } from "./CommentButton.vue?vue&type=template&id=d31863b6&scoped=true"
import script from "./CommentButton.vue?vue&type=script&lang=js"
export * from "./CommentButton.vue?vue&type=script&lang=js"
import style0 from "./CommentButton.vue?vue&type=style&index=0&id=d31863b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31863b6",
  null
  
)

export default component.exports